import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=65f16e4d&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=65f16e4d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f16e4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f16e4d')) {
      api.createRecord('65f16e4d', component.options)
    } else {
      api.reload('65f16e4d', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=65f16e4d&scoped=true", function () {
      api.rerender('65f16e4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/campaign/Detail.vue"
export default component.exports